import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Switch, useRouteMatch } from "react-router-dom";
import { browserHistory } from 'react-router'
import jwt_decode from "jwt-decode";
import setAuthToken from "./utils/setAuthToken";
import { setCurrentUser, logoutUser } from "./actions/authActions";
import { Provider } from "react-redux";
import store from "./store";



import Navbar from "./components/layout/Navbar";
import Landing from "./components/layout/Landing";
import Register from "./components/auth/Register";
import Login from "./components/auth/Login";
import AutoLogin from "./components/auth/AutoLogin";
import PrivateRoute from "./components/private-route/PrivateRoute";
import Dashboard from "./components/dashboard/Dashboard";
import Home from "./components/home/Home";
import HostScreen from "./components/home/HostScreen";
import Participant from "./components/home/Participant";
import Ondemand from "./components/home/Ondemand";
import PreConfiguration from "./components/home/PreConfiguration";
import SessionList from "./components/home/sessionList";
import Iframetemp from "./components/home/Iframetemp";
import Verification from "./components/auth/Verification";
import RegisterForm from './components/auth/RegisterForm';
import VerifyUserRegister from "./components/auth/VerifyUserRegister";
import Forgotpassword from "./components/auth/Forgotpassword";
import Verifylink from "./components/auth/Verifylink";
import ResetPassword from "./components/auth/ResetPassword"
import ComingSoon from "./components/auth/coming-soon"
import Tutorial from "./components/home/Tutorial";
import NotFound from "./components/errors/NotFound";
import PopupError from './components/home/PopupError';
import MarketplaceDashboard from "./components/home/MarketplaceDashboard";
import { loadElectron } from './utils/agora-electron';
import SessionDataStore from "./streaming/SessionDataStoreController";
import Util from "./streaming/Util";
import LoginPage from "./components/home/LoginPage";
import ForgotPasswordPage from "./components/home/ForgotPasswordPage";
import MarketplaceGlobal from "./components/home/MarketplaceGlobal";

loadElectron();

let matchRoute = window.location.href.split('/')[3];

// Check for token to keep user logged in
if (localStorage.userData && matchRoute !== 'auto-login' && !window['electron'] && matchRoute !== 'marketplaceglobal') {
  // Set auth token header auth
  const token = JSON.parse(localStorage.userData).token;

  setAuthToken(token);
  // Decode token and get user info and exp
  const decoded = jwt_decode(token);
  // Set user and isAuthenticated
  store.dispatch(setCurrentUser(decoded));
// Check for expired token
  const currentTime = Date.now() / 1000; // to get in milliseconds
  if (decoded.exp < currentTime) {
    // Logout user
    store.dispatch(logoutUser());
    // Redirect to login
    window.location.href  = window['electron'] ? 'index.html' : '/login';
  }
}

class App extends Component {
  
  componentDidCatch(error, errorInfo) {

      console.log('##error boundary ---- ', error, errorInfo);
		
	  if ( localStorage.userData )
		{
			  const userData = JSON.parse(localStorage.userData);
			  let sessionDataStore = SessionDataStore.getInstance();
			  let addObject = {"sessionId": userData.sessionData.id, "userId": userData.id, "event": "error", "eventType": "error", "details": JSON.stringify({"error": errorInfo}), "timestamp": Util.getCurrentTimestamp()};
			  sessionDataStore.addSessionData(addObject);
			  sessionDataStore.dumpData();
		}
  }

  render() {
    return (
      <Provider store={store}>
        <PopupError />
		<Router history={browserHistory}>
          <div className="App">
            <Navbar />
            <Switch>
              {/* <Route exact path="/coming-soon" component={ComingSoon} /> */}
              <Route exact path="/" component={LoginPage} />
              <Route exact path="/session-type" component={Register} />
              <Route exact path="/loginold/:err?" component={Login} />
              <Route exact path="/login/:err?" component={LoginPage} />
              <Route exact path="/verify" component={Verification} />
              <Route exact path="/register" component={RegisterForm} />
              <Route exact path="/iframetemp" component={Iframetemp} />
              <Route exact path="/verify-status" component={VerifyUserRegister} />
              <Route exact path="/forgotold" component={Forgotpassword} />
              <Route exact path="/forgot-password" component={ForgotPasswordPage} />
              <Route path="/verify-link/" component={Verifylink} />
              <Route exact path="/reset-password" component={ResetPassword} />
              <Route exact path="/coming-soon" component={ComingSoon} />
              <Route exact path="/auto-login/:id/:token/:ondemandId?" component={AutoLogin} />
          
              <PrivateRoute exact path="/dashboard" component={Dashboard} />
              <PrivateRoute exact path="/home" component={MarketplaceDashboard} />
              <PrivateRoute exact path="/pre-screen" component={PreConfiguration} />
              <PrivateRoute exact path="/session-list" component={SessionList} />
              <PrivateRoute exact path="/host" component={HostScreen} />
              <PrivateRoute exact path="/guest" component={Participant} />
              <PrivateRoute exact path="/tutorial" component={Tutorial} />
              <PrivateRoute exact path="/ondemand" component={Ondemand} />
			  <Route exact path="/marketplaceglobal" component={MarketplaceGlobal} />
              <Route component={NotFound} />
            </Switch>
			
			
			<div className="download_back_container" id="versionpop">     
				<div className="download_content">
					<div className="download_text">A new version of the</div>                
					<div className="download_text"><span className="relative_down">Virdio app is available <div className="rocket_emoji"></div></span></div>
					<div className="for_down_btn">
						<a href="" target="_blank" id="download_appbtn"><div className="down_btn">Download</div></a>
					</div>
					{ window.navigator.appVersion.indexOf('Windows') > 1 && 
						<div className="download_app_inner">
							Once you click on the Download and the Microsoft App Store opens<br></br>
							You should see a button to Download the new version of Virdio<br></br>
							If you see OPEN instead of UPDATE, click on the DETAILS button and you will see the Download button.
						</div>
					}
				</div>
			</div>

      <div className="download_back_container" id="appnotsupported">     
        <div className="download_content">
          <div className="download_text"><span className="relative_down">There is some issue with application..please contact Virdio support</span></div>
        </div>
      </div> 
          

      <div className="download_back_container" id="update_available">
        <div className="download_content">
          <div className="download_text">A new version of the</div>                
          <div className="download_text"><span className="relative_down">Virdio app is available. Downloading <div id="downloadpercent"></div></span></div>
        </div>
      </div> 
      
      <div className="download_back_container" id="restart_app">
        <div className="download_content">
          <div className="download_text">New version is downloaded.</div>
          <div className="download_text"><span className="relative_down">It will be installed on restart.</span></div>   
          <div className="for_down_btn">
            <div className="down_btn" id="restart_appbtn">Restart</div>
          </div>
        </div>
      </div>

		  </div>
        </Router>
      </Provider>
    );
  }
}
export default App;